import React from 'react';
import UUID from '../utility/UUID';
import ErrorContainer from '../components/ErrorContainer';
import ErrorMessage from '../components/ErrorMessage';
import { FieldValidationErrorsType } from '../form/FrekulForm';

function CustomCheckboxView({
  children,
  checked,
  setChecked,
  disabled = false,
}: {
  children: React.ReactNode,
  checked: boolean,
  setChecked: (checked: boolean) => void,
  disabled?: boolean
}) {
  const [uuid] = React.useState(UUID.generateUUID());
  return (
    <>
      <input
        type="checkbox"
        id={uuid}
        disabled={disabled}
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      <label htmlFor={uuid}>{children}</label>
    </>
  );
}

export default function CustomCheckbox({
  children,
  checked,
  setChecked,
  validationErrors = {},
  disabled = false,
}: {
  children: React.ReactNode,
  checked: boolean,
  setChecked: (checked: boolean) => void,
  validationErrors?: FieldValidationErrorsType,
  disabled?: boolean
}) {

  return (
    <>
      <ErrorContainer
        isError={Object.keys(validationErrors).length > 0}
      >
        <CustomCheckboxView checked={checked} setChecked={setChecked} disabled={disabled}>
          {children}
        </CustomCheckboxView>
      </ErrorContainer>
      <ErrorMessage type="error" validationErrors={validationErrors} />
    </>
  );
}

